import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { NguCarouselConfig, NguCarouselModule } from '@ngu/carousel';
import { Subject, Subscription, takeUntil } from 'rxjs';
import Swal from '../../services/swal-compat';
import { CustomerSubscribeDiscountsAdvantages } from '../../models/customer-class';
import { CustomerService } from '../../services/customer.service';
import { ValidateService } from '../../services/validate.service';
import { GlobalService } from '../../services/global.service';
import { BaseService } from '../../services/base.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatBottomSheet, MatBottomSheetConfig, MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatIconModule } from '@angular/material/icon';
import { SmileyComponent } from '../smiley-help/smiley/smiley.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,

    RouterModule,
    NguCarouselModule,
    TranslateModule,
    MatIconModule,
    MatBottomSheetModule,
    SmileyComponent,
  ],
})
export class FooterComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<void>();
  private subscriptions: Subscription[] = [];

  customerSubscribeDiscountsAdvantages: CustomerSubscribeDiscountsAdvantages;

  emailPlaceholder = ''; // vem do i18n
  currentYear = new Date().getFullYear();
  brand = 'Seguros Virtual';

  public carouselTileItems: Array<any> = [
    { logo: '/assets/logotipos/companhias/AgeasBranco.png', URL: 'https://www.ageas.pt/', alt: 'Ageas Seguros' },
    {
      logo: '/assets/logotipos/companhias/CaravelaBranco.png',
      URL: 'https://www.caravelaseguros.pt/',
      alt: 'Caravela Seguros',
    },
    { logo: '/assets/logotipos/companhias/InnovariskBranco.png', URL: 'https://innovarisk.pt/', alt: 'Innovarisk' },
    {
      logo: '/assets/logotipos/companhias/LusitaniaSegurosBranco.png',
      URL: 'https://www.lusitania.pt',
      alt: 'Lusitania Seguros',
    },
    {
      logo: '/assets/logotipos/companhias/RealVidaBranco.png',
      URL: 'https://www.realvidaseguros.pt',
      alt: 'Real Vida Seguros',
    },
    {
      logo: '/assets/logotipos/companhias/TranquilidadeBranco.png',
      URL: 'https://www.tranquilidade.pt',
      alt: 'Tranquilidade Seguros',
    },
  ];

  public carouselTile: NguCarouselConfig = {
    grid: { xs: 1, sm: 5, md: 5, lg: 5, xl: 5, all: 0 },
    slide: 5,
    speed: 1450,
    point: { visible: true },
    interval: { timing: 10000, initialDelay: 60000 },
    load: 5,
    velocity: 0,
    touch: true,
    loop: true,
    animation: 'lazy',
    easing: 'ease',
  };

  constructor(
    public dialog: MatDialog,
    public globalService: GlobalService,
    public validateService: ValidateService,
    private customerService: CustomerService,
    public baseService: BaseService,
    private t: TranslateService,
    private bottomSheet: MatBottomSheet,
  ) {
    this.limpaSubscricao();
  }

  async openCookieSettings() {
    const { CookiesalertComponent } = await import('../cookiesalert/cookiesalert.component');
    const config: MatBottomSheetConfig = {
      hasBackdrop: true,
      disableClose: false, // User can close it voluntarily here
      panelClass: 'bottom-sheet-container',
    };
    this.bottomSheet.open(CookiesalertComponent, config);
  }

  ngOnInit(): void {
    this.setEmailPlaceholder();
    // atualiza placeholder quando muda o idioma
    this.t.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(() => this.setEmailPlaceholder());
  }

  private setEmailPlaceholder() {
    this.emailPlaceholder = this.t.instant('COMMON.FOOTER.EMAIL_PLACEHOLDER');
  }

  clearEmailPlaceholder() {
    this.emailPlaceholder = '';
  }

  limpaSubscricao() {
    this.customerSubscribeDiscountsAdvantages = new CustomerSubscribeDiscountsAdvantages();
    this.customerSubscribeDiscountsAdvantages.DateStart = new Date();
    this.customerSubscribeDiscountsAdvantages.Description = 'Subscrição Footer';
    this.customerSubscribeDiscountsAdvantages.Email = '';
    this.customerSubscribeDiscountsAdvantages.Order = 0;
  }

  subscribe() {
    if (this.validateService.isEmail(this.customerSubscribeDiscountsAdvantages.Email)) {
      this.subscriptions.push(
        this.customerService
          .ClientAreaSetSubscribeDiscountsAdvantagesByEmail(this.customerSubscribeDiscountsAdvantages, '')
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            error: error => {
              Swal.fire(
                this.t.instant('COMMON.FOOTER.SUBSCRIBE_ERROR_TITLE'),
                this.t.instant('COMMON.FOOTER.SUBSCRIBE_ERROR_MSG'),
                'error',
              );
              console.log(error);
            },
            complete: () => {
              this.limpaSubscricao();
              Swal.fire(
                this.t.instant('COMMON.FOOTER.SUBSCRIBE_SUCCESS_TITLE'),
                this.t.instant('COMMON.FOOTER.SUBSCRIBE_SUCCESS_MSG'),
                'success',
              );
            },
          }),
      );
    } else {
      Swal.fire(
        this.t.instant('COMMON.FOOTER.EMAIL_INVALID_TITLE'),
        this.t.instant('COMMON.FOOTER.EMAIL_INVALID_MSG'),
        'warning',
      );
    }
  }

  ngOnDestroy() {
    if (!this.destroy$.closed) {
      this.destroy$.next();

      this.destroy$.complete();
    }
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
